import {
    ChangeDetectionStrategy,
    Component,
    computed,
    input,
    OnInit,
    signal,
    Signal,
    ViewEncapsulation,
    WritableSignal,
} from '@angular/core';
import { TableData } from '../../../models/table-data';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-collapsible-table',
    templateUrl: './collapsible-table.component.html',
    styleUrls: ['./collapsible-table.component.scss'],
    imports: [CommonModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class CollapsibleTableComponent implements OnInit {
    public tableData: Signal<TableData> = input<TableData>();

    protected active: WritableSignal<number> = signal<number>(0);
    private contentLength: Signal<number> = computed(() => this.tableData().rows[0]?.cells.length || 0);
    protected tableWidth: Signal<number> = computed(() =>
        this.tableData().fixTitleRow ? this.contentLength() : this.contentLength() + 1,
    );
    protected subtitles: Signal<string[]> = computed(() =>
        this.tableData().fixTitleRow ? this.tableData().subtitles : this.tableData().subtitles.slice(1),
    );
    protected hasCollapsedTitle: Signal<boolean> = computed(
        () => !this.tableData().fixTitleRow || !!this.tableData().collapsedTitle || !!this.tableData().title,
    );

    public ngOnInit(): void {
        this.active.set(this.tableData().highlighted || 0);
    }

    protected handleKeydown(e: KeyboardEvent): void {
        const target = e.target as HTMLElement;
        if (!target || target.getAttribute('role') !== 'tab') {
            return;
        }

        const tablist = target.closest('[role="tablist"]');
        if (!tablist) {
            return;
        }

        const tabs = Array.from(tablist.querySelectorAll<HTMLButtonElement>('button[role="tab"]'));

        const currentIndex = tabs.findIndex((tab) => tab === target);
        if (currentIndex === -1) {
            return;
        }

        let nextIndex = currentIndex;

        switch (e.key) {
            case 'ArrowLeft':
                nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
                break;
            case 'ArrowRight':
                nextIndex = (currentIndex + 1) % tabs.length;
                break;
            case 'Home':
                nextIndex = 0;
                break;
            case 'End':
                nextIndex = tabs.length - 1;
                break;
            default:
                return;
        }

        e.preventDefault();
        tabs[nextIndex].focus();
    }

    protected activate(i: number): void {
        this.active.set(i);
    }
}
